/**
 * Implements queued modals.
 */
var ModalQueue = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	p.modals = [];
	p.anyOpen = false;
	p.documentReady = false;

	function constructor() {
		var self = this;
		for ( const modal of document.querySelectorAll( '.modal--queued' ) ) {
			this.enqueue( modal );
		}
		jQuery( document ).ready( function() {
			self.documentReady = true;
			self.next();
		});
	};

	// Enqueue modal
	p.enqueue = function( modal ) {
		var self = this;
		jQuery( modal ).on( 'hidden.bs.modal', function() {
			self.anyOpen = false;
			self.next();
		} );
		this.modals.push( modal );
		if ( this.documentReady ) {
			this.next();
		}
	};

	// Show next modal if none open
	p.next = function() {
		if ( this.anyOpen ) {
			return;
		}
		if ( this.modals.length ) {
			this.anyOpen = true;
			var nextModal = this.modals.shift();
			jQuery( nextModal ).modal('show');
		}
	};

	return C;
} )();

export default ModalQueue;